import { GuardFn, GuardParams, GuardRef, registerGuard } from './register-guard';
import { SoftAppsLogoutService } from '../services/logout.service';
import { assertInInjectionContext, inject, INJECTOR, Signal } from '@angular/core';

export function canLogout(guardParams: GuardParams): Signal<GuardRef | undefined>;
export function canLogout(guardFn: GuardFn): Signal<GuardRef | undefined>;
export function canLogout(
  guardFnOrParams: GuardFn | GuardParams
): Signal<GuardRef | undefined> {
  assertInInjectionContext(canLogout);

  let params: GuardParams;

  if (typeof guardFnOrParams === 'function') {
    params = {
      active: true,
      guard: guardFnOrParams,
      injector: inject(INJECTOR),
    };
  } else {
    params = {
      active: guardFnOrParams.active,
      guard: guardFnOrParams.guard,
      injector: guardFnOrParams?.injector ?? inject(INJECTOR),
    };
  }

  return registerGuard(SoftAppsLogoutService.GUARD_TYPE, params);
}
